<template>
  <div id="item-footer" :class="{ white: withBackground }">
    <item-description ref="description" id="description"/>
    <cta-button ref="cta" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      item: state => state.item
    }),
    withBackground: function(){
      if(this.$root.isOwner) return true;
      if(this.item.attributes.description) return true;

      return false;
    }
  },
}
</script>

<style lang="scss" scoped>
  @import '@/packs/application.scss';

  #item-footer {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin: 0 40px 1rem;
    border-radius: 5px;
    padding: 1rem;

    &.white {
      background: rgba(255,255,255,0.7);
    }
  }

  #description {
    flex-grow: 2;
  }
</style>
